angular.module('shared').directive('formattedDateBinding', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(viewValue) {
        var parsed, typed, typedAsDisplay, typedAsModel;
        // Free-typed text reaches this parser already coerced through a loose
        // new Date() fallback (e.g. '0' -> 1 Jan 2000, '0104' -> year 104 on
        // Safari), so validate the raw input text strictly against the
        // display/model formats before trusting the parsed value. The raw text
        // is read from $viewValue rather than element.val() because a calendar
        // pick sets the view value (a Date) before re-rendering the input, so
        // element.val() would still hold the stale typed text at parse time.
        typed = ngModel.$viewValue;
        if (angular.isString(typed) && typed) {
          typedAsDisplay = moment(typed, attrs.datepickerPopup.toUpperCase(), true);
          typedAsModel = moment(typed, attrs.formattedDateBinding, true);
          if (!typedAsDisplay.isValid() && !typedAsModel.isValid()) {
            return void 0;
          }
        }
        parsed = moment(viewValue);
        if (!parsed.isValid()) {
          return void 0;
        }
        if (scope.minDate && parsed.isBefore(moment(scope.minDate), 'day')) {
          return void 0;
        }
        if (scope.maxDate && parsed.isAfter(moment(scope.maxDate), 'day')) {
          return void 0;
        }
        return parsed.format(attrs.formattedDateBinding);
      });
      // Rejected text would otherwise stay visible in the input while the
      // model holds nothing, looking like it was accepted.
      element.on('blur', function() {
        if (!ngModel.$modelValue && element.val()) {
          return element.val('');
        }
      });
      return ngModel.$formatters.push(function(viewValue) {
        if (moment(viewValue, 'DD-MM-YYYY', true).isValid()) {
          return moment(viewValue, 'DD-MM-YYYY').format(attrs.datepickerPopup.toUpperCase());
        }
        if (moment(viewValue, 'YYYY-MM-DD', true).isValid()) {
          return moment(viewValue, 'YYYY-MM-DD').format(attrs.datepickerPopup.toUpperCase());
        }
      });
    }
  };
});
